<template>
  <div class="tradeFinance">
    <sirui-search
      ref="siruiSearch"
      :query="searchForm"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="search"
      @changeCompany="changeCompany"
    ></sirui-search>
    <!-- 表格 -->
    <div class="main-content">
      <vxe-toolbar size="mini" :style="{ display: menuButtonList.length == 0 ? 'none' : 'block' }">
        <template v-slot:buttons>
          <template v-for="item in menuButtonList">
            <vxe-button
              type="primary"
              :icon="item.attributes.buttonStyle"
              :style="
                'background-color:' +
                (item.label == $t('businesDepartment.businesList.delete') ||
                item.label == $t('businesDepartment.businesList.forbidden')
                  ? '#FE8783'
                  : 'rgb(98, 153, 254)') +
                ';border:1px solid ' +
                (item.label == $t('businesDepartment.businesList.delete') ||
                item.label == $t('businesDepartment.businesList.forbidden')
                  ? '#FE8783'
                  : 'rgb(98, 153, 254)')
              "
              :key="item.id"
              class="btn"
              :loading="loadBtn"
              @click="chooseClick(item.attributes.buttonUrl, item)"
              >{{ item.label }}</vxe-button
            >
          </template>
        </template>
      </vxe-toolbar>
      <vxe-grid
        border
        show-overflow
        resizable
        ref="xTable"
        class="vxe-table-element"
        size="mini"
        align="left"
        min-width="120"
        :row-id="rowKey"
        :loading="load"
        :edit-actived="activeIndex"
        :auto-resize="true"
        :data="tableData"
        :edit-rules="validRules"
        :edit-config="{ trigger: 'click', mode: 'row', activeMethod: activeRowMethod }"
        :checkbox-config="{ reserve: reserve, checkRowKeys: checkRowKeys }"
        :radio-config="{ checkRowKey: checkRowKeys.join(',') }"
        @cell-click="getActiveIndex"
        @cell-dblclick="dblclickEvent"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        @edit-actived="editActivedEvent"
      >
        <vxe-table-column type="checkbox" width="50"></vxe-table-column>
        <vxe-table-column
          type="index"
          :title="$t('currenciesAndCalendar.queryCurrencies.index')"
          width="50"
        ></vxe-table-column>
        <vxe-table-column
          field="planCompanyCode"
          :title="$t('businesDepartment.businesList.company')"
          :edit-render="{ type: 'default' }"
          width="210"
        >
          <template v-slot:edit="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="getSelectLabel(scope.row.planCompanyCode, companyList)"
              placement="top"
              :disabled="
                scope.row.planCompanyCode == '' || scope.row.planCompanyCode == null ? true : false
              "
            >
              <el-select
                v-model="scope.row.planCompanyCode"
                filterable
                @change="changeCompany(scope)"
                clearable
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in companyList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-tooltip>
          </template>
          <template v-slot="{ row }">{{
            getSelectLabel(row.planCompanyCode, companyList) || row.planCompanyName
          }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="planDepartmentCode"
          :title="$t('businesDepartment.businesList.department')"
          :edit-render="{ type: 'default' }"
          width="210"
        >
          <template v-slot:edit="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.planDepartmentName"
              placement="top"
              :disabled="
                scope.row.planDepartmentCode == '' || scope.row.planDepartmentCode == null
                  ? true
                  : false
              "
            >
              <el-select
                v-model="scope.row.planDepartmentCode"
                filterable
                @change="departmentChange(scope)"
                clearable
              >
                <el-option
                  v-for="item in planDepartmentList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-tooltip>
          </template>
          <template v-slot="{ row }">{{ row.planDepartmentName }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="planCycle"
          :title="$t('businesDepartment.businesList.planWeek')"
          width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-select
              v-model="scope.row.planCycle"
              filterable
              @change="$refs.xTable.updateStatus(scope)"
            >
              <el-option
                v-for="item in planWeekList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-slot="{ row }">{{ getSelectLabel(row.planCycle, planWeekList) }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="year"
          :title="$t('businesDepartment.businesList.year')"
          width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-select
              v-model="scope.row.year"
              filterable
              @change="$refs.xTable.updateStatus(scope)"
            >
              <el-option
                v-for="item in yearList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-slot="{ row }">{{ getSelectLabel(row.year, yearList) }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="month"
          :title="$t('businesDepartment.businesList.month')"
          width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-select
              v-model="scope.row.month"
              filterable
              @change="$refs.xTable.updateStatus(scope)"
            >
              <el-option
                v-for="item in monthList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-slot="{ row }">{{ getSelectLabel(row.month, monthList) }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="planStartDate"
          :title="$t('businesDepartment.businesList.planStartDate')"
          width="200"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="{ row }">
            <el-date-picker
              v-model="row.planStartDate"
              type="date"
              format="yyyy/MM/dd"
            ></el-date-picker>
          </template>
          <template v-slot="{ row }">{{ formatDate(row.planStartDate, 'yyyy/MM/dd') }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="planEndDate"
          :title="$t('businesDepartment.businesList.planEndDate')"
          width="200"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="{ row }">
            <el-date-picker
              v-model="row.planEndDate"
              type="date"
              format="yyyy/MM/dd"
            ></el-date-picker>
          </template>
          <template v-slot="{ row }">{{ formatDate(row.planEndDate, 'yyyy/MM/dd') }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="financeBank"
          :title="$t('businesDepartment.financing.financeBank')"
          width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="getSelectLabel(scope.row.financeBank, financingBankList)"
              placement="top"
              :disabled="
                scope.row.financeBank == '' || scope.row.financeBank == null ? true : false
              "
            >
              <el-select
                v-model="scope.row.financeBank"
                filterable
                @change="$refs.xTable.updateStatus(scope)"
                clearable
              >
                <el-option
                  v-for="item in financingBankList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-tooltip>
          </template>
          <template v-slot="{ row }">{{
            getSelectLabel(row.financeBank, financingBankList)
          }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="financeVariety"
          :title="$t('businesDepartment.financing.financeVariety')"
          width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="getSelectLabel(scope.row.financeVariety, financingVarietiesList)"
              placement="top"
              :disabled="
                scope.row.financeVariety == '' || scope.row.financeVariety == null ? true : false
              "
            >
              <el-select
                v-model="scope.row.financeVariety"
                filterable
                @change="$refs.xTable.updateStatus(scope)"
                clearable
              >
                <el-option
                  v-for="item in financingVarietiesList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-tooltip>
          </template>
          <template v-slot="{ row }">{{
            getSelectLabel(row.financeVariety, financingVarietiesList)
          }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="receiveDate"
          :title="$t('businesDepartment.tradeFinance.receiveDate')"
          width="200"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="{ row }">
            <el-tooltip
              class="item"
              effect="dark"
              :content="formatDate(row.receiveDate, 'yyyy/MM/dd') + ''"
              placement="top"
              :disabled="row.receiveDate == '' || row.receiveDate == null ? true : false"
            >
              <el-date-picker
                v-model="row.receiveDate"
                type="date"
                format="yyyy/MM/dd"
                clearable
              ></el-date-picker>
            </el-tooltip>
          </template>
          <template v-slot="{ row }">{{ formatDate(row.receiveDate, 'yyyy/MM/dd') }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="receiveAmount"
          :title="$t('businesDepartment.businesList.receiveAmount')"
          min-width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.receiveAmount + ''"
              placement="top"
              :disabled="
                scope.row.receiveAmount == '' || scope.row.receiveAmount == null ? true : false
              "
            >
              <input-number
                v-model="scope.row.receiveAmount"
                :max="99999999999.999999"
                :clearable="true"
                @input="$refs.xTable.updateStatus(scope)"
              ></input-number>
              <!-- <el-input v-model="scope.row.receiveAmount" @input="$refs.xTable.updateStatus(scope)" clearable maxlength="32"></el-input> -->
            </el-tooltip>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="payDate"
          :title="$t('businesDepartment.tradeFinance.payDate')"
          width="200"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="{ row }">
            <el-tooltip
              class="item"
              effect="dark"
              :content="formatDate(row.payDate, 'yyyy/MM/dd') + ''"
              placement="top"
              :disabled="row.payDate == '' || row.payDate == null ? true : false"
            >
              <el-date-picker
                v-model="row.payDate"
                type="date"
                format="yyyy/MM/dd"
                clearable
              ></el-date-picker>
            </el-tooltip>
          </template>
          <template v-slot="{ row }">{{ formatDate(row.payDate, 'yyyy/MM/dd') }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="payAmount"
          :title="$t('businesDepartment.businesList.payAmount')"
          min-width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.payAmount + ''"
              placement="top"
              :disabled="scope.row.payAmount == '' || scope.row.payAmount == null ? true : false"
            >
              <input-number
                v-model="scope.row.payAmount"
                :max="99999999999.999999"
                :clearable="true"
                @input="$refs.xTable.updateStatus(scope)"
              ></input-number>
            </el-tooltip>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="currencyType"
          :title="$t('businesDepartment.businesList.currencyType')"
          width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="
                getSelectLabel(scope.row.currencyType, currencyList) || scope.row.currencyType
              "
              placement="top"
              :disabled="
                scope.row.currencyType == '' || scope.row.currencyType == null ? true : false
              "
            >
              <el-select
                v-model="scope.row.currencyType"
                filterable
                @change="$refs.xTable.updateStatus(scope)"
                clearable
              >
                <el-option
                  v-for="item in currencyList"
                  :key="item.value"
                  :label="item.label + '  ' + item.value"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-tooltip>
          </template>
          <template v-slot="{ row }">{{ getSelectLabel(row.currencyType, currencyList) }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="planDays"
          :title="$t('businesDepartment.tradeFinance.planDays')"
          min-width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.planDays + ''"
              placement="top"
              :disabled="scope.row.planDays == '' || scope.row.planDays == null ? true : false"
            >
              <input-number
                v-model="scope.row.planDays"
                :max="999999999.999999"
                :precision="$globalVar.dPoint"
                :clearable="true"
                @input="$refs.xTable.updateStatus(scope)"
              ></input-number>
            </el-tooltip>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="interestRate"
          :title="$t('businesDepartment.tradeFinance.interestRate')"
          min-width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.interestRate + ''"
              placement="top"
              :disabled="
                scope.row.interestRate == '' || scope.row.interestRate == null ? true : false
              "
            >
              <input-number
                v-model="scope.row.interestRate"
                :max="100.0"
                :precision="3"
                :clearable="true"
                @input="$refs.xTable.updateStatus(scope)"
              ></input-number>
            </el-tooltip>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="planInterest"
          :title="$t('businesDepartment.tradeFinance.planInterest')"
          min-width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.planInterest + ''"
              placement="top"
              :disabled="
                scope.row.planInterest == '' || scope.row.planInterest == null ? true : false
              "
            >
              <input-number
                v-model="scope.row.planInterest"
                :max="99999999999.999999"
                :precision="6"
                :clearable="true"
                @input="$refs.xTable.updateStatus(scope)"
              ></input-number>
            </el-tooltip>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="mark"
          :title="$t('businesDepartment.businesList.mark')"
          min-width="140"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.mark"
              placement="top"
              :disabled="scope.row.mark == '' || scope.row.mark == null ? true : false"
            >
              <el-input
                v-model="scope.row.mark"
                @input="$refs.xTable.updateStatus(scope)"
                clearable
                maxlength="256"
              ></el-input>
            </el-tooltip>
          </template>
        </vxe-table-column>
      </vxe-grid>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          ref="page"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-count="page.pages"
          :page-size="page.pageSize"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/capitalPlane/tradeFinance';
  import SiruiSearch from '@/components/SiruiSearch';
  import InputNumber from '@/components/form-item/input-number';
  import BASEAPI from '@/api/dataBase.js';
  import tableMixins from '@/common/mixins/table.js';
  import XEUtils from 'xe-utils';
  export default {
    name: 'tradeFinance',
    mixins: [tableMixins],
    components: {
      SiruiSearch,
      InputNumber,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      user() {
        return this.userInfo;
      },
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'planCompanyCode',
            name: this.$t('businesDepartment.businesList.company'),
            type: 'select',
            options: this.companyList,
            changeMethod: 'changeCompany',
          },
          //   事业部门
          {
            prop: 'planDepartmentCode',
            name: this.$t('businesDepartment.businesList.department'),
            type: 'select',
            options: this.departmentList,
          },
          // {
          //   prop: "planDepartmentCode",
          //   name:  this.$t('businesDepartment.businesList.department'),
          //   type: "treeSelect",
          //   apiUrl: BASEAPI.LIST_COMPANY_API,
          //   apiData: {
          //     tenantCode: this.userInfo.tenantCode,
          //     adminFlag: this.userInfo.adminFlag
          //   },
          //   multiple: true,
          //   isName: false,
          //   clearable: false
          // },
          {
            prop: 'financeVarietyList',
            name: this.$t('businesDepartment.financing.financeVariety'),
            type: 'selectMultiple',
            options: this.financingVarietiesList,
          },
          {
            prop: 'financeBankList',
            name: this.$t('businesDepartment.financing.financeBank'),
            type: 'selectMultiple',
            options: this.financingBankList,
          },
          {
            prop: 'planCycle',
            name: this.$t('businesDepartment.businesList.planWeek'),
            type: 'dict',
            dictType: 'capitalPlan_plan_week',
          },
          {
            prop: 'planStartDate',
            name: this.$t('businesDepartment.businesList.planStartDate'),
            type: 'date',
          },
          {
            prop: 'planEndDate',
            name: this.$t('businesDepartment.businesList.planEndDate'),
            type: 'date',
          },
          /* {
          prop: "planStartDateStart",
          name: this.$t("businesDepartment.businesList.planStartDateStart"),
          type: "startDaterangePicker"
        },
        {
          prop: "planStartDateEnd",
          name: this.$t("businesDepartment.businesList.planStartDateEnd"),
          type: "endDaterangePicker"
        },
        {
          prop: "planEndDateStart",
          name: this.$t("businesDepartment.businesList.planEndDateStart"),
          type: "startDaterangePicker"
        },
        {
          prop: "planEndDateEnd",
          name: this.$t("businesDepartment.businesList.planEndDateEnd"),
          type: "endDaterangePicker"
        } */
        ];
      },
    },
    data() {
      return {
        planWeekList: [],
        validRules: {
          planCompanyCode: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.companyValidRules')}`,
            },
          ],
          planDepartmentCode: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.departmentValidRules')}`,
            },
          ],
          planCycle: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.planCycleValidRules')}`,
            },
          ],
          year: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.yearValidRules')}`,
            },
          ],
          month: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.monthValidRules')}`,
            },
          ],
          financeVariety: [
            {
              required: true,
              message: this.$t('businesDepartment.financing.financeVarietyValidRules'),
            },
          ],
          financeBank: [
            {
              required: true,
              message: this.$t('businesDepartment.financing.financeBankValidRules'),
            },
          ],
          //收款金额
          receiveAmount: [
            {
              min: 0,
              max: 20,
              message: this.$t('currenciesAndCalendar.rules.writeLength'),
            },
          ],
          //付款金额
          payAmount: [
            {
              min: 0,
              max: 20,
              message: this.$t('currenciesAndCalendar.rules.writeLength'),
            },
          ],
          currencyType: [
            {
              required: true,
              message: this.$t('businesDepartment.financing.currencyValidRules'),
            },
          ],
          // 天数
          planDays: [
            {
              min: 0,
              max: 20,
              message: this.$t('currenciesAndCalendar.rules.writeLength'),
            },
          ],
          //利率
          interestRate: [
            {
              min: 0,
              max: 20,
              message: this.$t('currenciesAndCalendar.rules.writeLength'),
            },
          ],
          //利息
          planInterest: [
            {
              min: 0,
              max: 20,
              message: this.$t('currenciesAndCalendar.rules.writeLength'),
            },
          ],
          //备注
          mark: [
            {
              min: 0,
              max: 256,
              message: this.$t('currenciesAndCalendar.rules.writeLength'),
            },
          ],
        },
        rowKey: 'id',
        checkRowKeys: [],
        reserve: true,
        activeIndex: '', // 激活行索引
        menuButtonList: [], // 按钮
        load: false,
        loadBtn: false,
        tableData: [], //表格数据
        multipleSelection: [], //选中行
        searchForm: {
          planCompanyCode: null,
          planDepartmentCode: null,
          financeVarietyList: null, //融资品种
          financeBankList: null, //融资银行
          planCycle: null, //计划周期
          planStartDateStart: null, //计划开始日期起
          planStartDateEnd: null, //计划开始日期止
          planEndDateStart: null, //计划结束日期起
          planEndDateEnd: null, //计划结束日期止
        }, // 搜索条件
        page: {
          pages: 1,
          pageSize: 10,
          pageNum: 1,
          total: 0,
        }, //分页
        companyList: [], //公司列表
        currencyList: [], //币别
        companyDepartmentList: [],
        departmentList: [], //部门列表
        planDepartmentList: [],
        financingVarietiesList: [], //融资品种
        financingBankList: [], //融资银行
        yearList: [], //年度
        monthList: [
          {
            value: '1',
            label: '1' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '2',
            label: '2' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '3',
            label: '3' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '4',
            label: '4' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '5',
            label: '5' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '6',
            label: '6' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '7',
            label: '7' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '8',
            label: '8' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '9',
            label: '9' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '10',
            label: '10' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '11',
            label: '11' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '12',
            label: '12' + this.$t('businesDepartment.businesList.mon'),
          },
        ], //月份
      };
    },
    mounted() {
      this.getButtonList();
      this.getData();
      this.getDictionary();
    },
    methods: {
      getData() {
        const params = JSON.parse(JSON.stringify(this.searchForm));
        XEUtils.objectEach(params, (item, key) => {
          if (XEUtils.isArray(item) && XEUtils.isEmpty(item)) delete params[key];
        });
        params.pageSize = this.page.pageSize;
        params.pageNum = this.page.pageNum;
        this.load = true;
        this.$axios.post(API.SELECT_TRADE_FINANCE_BYPAGE, params).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.tableData.forEach((item) => {
              item.companyDepartment = [item.planCompanyCode, item.planDepartmentCode];
            });
            this.page.total = res.data.data.total;
          }
        });
      },
      handleChange(value) {
        this.tableData.forEach((item) => {
          if (item._XID == value._XID) {
            item.planCompanyCode = value.companyDepartment[0];
            item.planDepartmentCode = value.companyDepartment[1];
            this.companyDepartmentList.forEach((res) => {
              if (res.value == item.planCompanyCode) {
                item.planCompanyName = res.label;
                res.children.forEach((val) => {
                  if (val.value == item.planDepartmentCode) {
                    item.planDepartmentName = val.label;
                  }
                });
              }
            });
          }
        });
      },
      getCascaderLabel(val, value, list) {
        let values = value || [];
        let labels = [];
        let matchCascaderData = function (index, list) {
          let val = values[index];
          if (list && values.length > index) {
            list.forEach((item) => {
              if (item.value === val) {
                labels.push(item.label);
                matchCascaderData(++index, item.children);
              }
            });
          }
        };
        matchCascaderData(0, list);
        if (val == 1) {
          return labels[0];
        } else {
          return labels[1];
        }
      },
      //创建
      creatFinancing() {
        let val = {
          path: '/capitalPlan/safeguardTradeFinancing',
          name: 'safeguardTradeFinancing',
          title: this.$t('businesDepartment.tradeFinance.toSafeguardTradeFinancing'),
        };
        this.toRouter(val);
      },
      //修改
      reviseFinancing() {
        let selectedList = this.$refs.xTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length <= 0) {
          this.$message({
            showClose: true,
            type: 'error',
            message: this.$t('businesDepartment.businesList.selectOnechangeEdit'),
          });
        } else {
          let val = {
            path: '/capitalPlan/safeguardTradeFinancing',
            name: 'safeguardTradeFinancing',
            title: this.$t('businesDepartment.tradeFinance.toSafeguardTradeFinancing'),
          };
          let id = changeList.map((item) => {
            return item.id;
          });
          this.toRouter(val, 1, id);
        }
      },
      //删除
      deletFinancing() {
        let selectedList = this.$refs.xTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          this.$confirmAction()
            .then(() => {
              let ids = changeList.map((item) => {
                return item.id;
              });
              let params = {
                idList: ids,
              };
              this.$axios.post(API.DELETE_TRADE_FINANCE, params).then((res) => {
                if (res.data.code == 0) {
                  this.$message({
                    showClose: true,
                    type: 'success',
                    message: res.data.msg,
                  });
                  this.getData();
                } else {
                  this.$alert(res.data.msg);
                }
              });
            })
            .catch(() => {
              this.$message({
                showClose: true,
                type: 'info',
                message: this.$t('personnel.table.deletFalse'),
              });
            });
        } else {
          this.$message({
            showClose: true,
            type: 'error',
            message: this.$t('businesDepartment.businesList.pleaseChangeDelete'),
          });
        }
      },
      activeRowMethod() {
        //禁用编辑
        return false;
      },
      editActivedEvent(row) {
        this.changeCompany(row);
      },
      // 获取公司部门
      async changeCompany(val) {
        this.searchForm.planDepartmentCode = null;
        let personDepartmentInfo = [];
        if (val) {
          let res = await this.$baseRequest.getDepartment(val.val);
          if (res) {
            this.departmentList = res;
          }
        } else {
          this.planDepartmentList = personDepartmentInfo;
        }
        if (val.row && val.row.planCompanyCode) {
          this.$refs.xTable.updateStatus(val);
        }
      },
      departmentChange(val) {
        if (val.row.planDepartmentCode) {
          val.row.planDepartmentName = this.planDepartmentList.find(
            (item) => item.value === val.row.planDepartmentCode
          ).label;
        } else {
          val.row.planDepartmentName = '';
        }
        this.$refs.xTable.updateStatus(val);
      },
      //校验+保存
      save() {
        if (this.tableData.length <= 0) {
          this.$message({
            showClose: true,
            message: this.$t('businesDepartment.businesList.noSaveMates'),
            type: 'error',
          });
        } else {
          this.flag = true;
          // let formList = ['xTable'];
          let resultArr = [];
          // let _self = this;
          // function validates(formName) {
          //   let result = new Promise((resolve, reject) => {
          //     _self.$refs[formName]
          //       .validate()
          //       .then(() => {
          //         resolve();
          //       })
          //       .catch(() => {
          //         reject();
          //       });
          //   });
          //   resultArr.push(result);
          // }
          // formList.forEach((item) => {
          //   validates(item); // 循环校验
          // });
          this.tableData = this.$refs.xTable.getTableData().fullData;
          return Promise.all(resultArr)
            .then(() => {
              //保存
              const { tenantCode, companyCode, departmentCode, companyName, departmentName } =
                this.userInfo;
              this.tableData.forEach((item) => {
                item.tenantCode = tenantCode;
                item.companyCode = companyCode;
                item.departmentCode = departmentCode;
                item.companyName = companyName;
                item.departmentName = departmentName;
                item.planCompanyName = this.companyList.find(
                  (res) => res.value === item.planCompanyCode
                ).label;
                this.financingBankList.forEach((i) => {
                  if (item.financeBank == i.value) {
                    item.financeBankName = i.label;
                  }
                });
                //解决 axios 提交时间类型参数遇到的时区自动转换问题
                item.planStartDate = Date.parse(item.planStartDate + 'GMT +8');
                item.planEndDate = Date.parse(item.planEndDate + 'GMT +8');
              });
              let parames = {
                planTradeFinanceList: JSON.parse(JSON.stringify(this.tableData)),
              };
              this.loadBtn = true;
              this.$axios.post(API.INSERT_TRADE_FINANCE, parames).then((res) => {
                this.loadBtn = false;
                if (res.data.code == 0) {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'success',
                  });
                  this.getData();
                } else {
                  this.$alert(res.data.msg);
                }
              });
            })
            .catch(() => {});
        }
      },
      //路由跳转
      toRouter(val, show, value) {
        let path = {
          path: val.path,
          name: val.name,
          meta: {
            keepAlive: true,
            title: val.title,
          },
        };
        if (value) {
          path.query = { id: value, isShow: show };
        } else {
          path.query = { isShow: 0 };
        }
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //双击事件
      dblclickEvent(value) {
        let val = {
          path: '/capitalPlan/safeguardTradeFinancing',
          name: 'safeguardTradeFinancing',
          title: this.$t('businesDepartment.tradeFinance.toSafeguardTradeFinancing'),
        };
        let ids = [];
        ids.push(value.row.id);
        this.toRouter(val, 0, ids);
      },
      //点击按钮触发的方法
      chooseClick(type) {
        if (type == 'add') {
          this.creatFinancing();
        } else if (type == 'edit') {
          this.reviseFinancing();
        } else if (type == 'delete') {
          this.deletFinancing();
        } else if (type == 'save') {
          this.save();
        } else if (type == 'export') {
          this.exportPerson();
        }
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
        });
      },
      //编辑表格回显方法
      getSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      //表格日期回显
      formatDate(value, format) {
        return XEUtils.toDateString(value, format);
      },
      //导出功能
      exportPerson() {
        if (this.tableData.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'error',
          });
        }
        const selectedList = this.$refs.xTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          // let ids = changeList.forEach((item) => {
          //   str += 'ids=' + item.id + '&';
          // });
          window.location.href = `${this.baseUrl}${API.SELECT_TRADE_FINANCE_EXPORT}?${str}access_token=${this.userInfo.access_token}`;
        } else {
          let params = { ...this.searchForm };
          params = XEUtils.serialize(params);
          window.location.href = `${this.baseUrl}${API.SELECT_TRADE_FINANCE_EXPORT}?${params}&access_token=${this.userInfo.access_token}`;
        }
      },
      // 重置
      resetBtnClick() {
        this.page.pages = 1;
        this.page.pageSize = 10;
        this.page.pageNum = 1;
        this.getData();
      },
      //查询
      search() {
        this.getData();
      },
      // 选中事件
      handleSelectionChange(val) {
        this.multipleSelection = val.selection;
      },
      // 获取当前激活行索引
      getActiveIndex(value) {
        this.activeIndex = value.rowIndex;
      },
      handleSizeChange(value) {
        this.page.pageSize = value;
        this.getData();
      },
      handleCurrentChange(value) {
        this.page.pageNum = value;
        this.getData();
      },
      //字典值
      getDictionary() {
        this.getFinancingVarietiesList();
        this.getCurrencyList();
        this.getsearchCompany();
        this.getCompany();
        this.getBankList();
        this.getYearList();
        this.getPlanWeekList();
      },
      //获取计划周期
      async getPlanWeekList() {
        let params = {
          dictType: 'capitalPlan_plan_week',
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_DICTBYDATACODE, params);
        if (selectStatus.data.code == 0) {
          this.planWeekList = selectStatus.data.data;
        }
      },
      //获取当前年度
      getYearList() {
        let date = new Date();
        let year = date.getFullYear();
        year = year - 11;
        for (let i = 0; i < 21; i++) {
          year = year + 1;
          let object = { value: `${year}`, label: year };
          this.yearList.push(object);
        }
      },
      //获取融资品种
      async getFinancingVarietiesList() {
        let params = {
          dictType: 'finance_variety',
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_DICTBYDATACODE, params);
        if (selectStatus.data.code == 0) {
          this.financingVarietiesList = selectStatus.data.data;
        }
      },
      //获取币别
      async getCurrencyList() {
        const selectStatus = await this.$axios.get(BASEAPI.LIST_CURRENCY);
        if (selectStatus.data.code == 0) {
          selectStatus.data.data.map((item) => {
            let obj = {
              value: item.currencyCode,
              label: item.currencyName,
            };
            this.currencyList.push(obj);
          });
        }
      },
      //获取搜索框当前公司
      async getsearchCompany() {
        let parames = {
          belongTenantCode: this.user.tenantCode,
          currentStatus: 0,
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_SERECHCOMPANYTREE, parames);

        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data;
        }
      },
      //获取表格公getBankList司
      async getCompany() {
        let parames = {
          belongTenantCode: this.user.tenantCode,
          currentStatus: 0,
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_SERECHCOMPANYTREE, parames);
        if (selectStatus.data.code == 0) {
          this.companyDepartmentList = selectStatus.data.data;
        }
      },
      async getBankList() {
        this.financingBankList = await this.$baseRequest.getMDBank();
        this.financingBankList = this.financingBankList.map((item) => {
          return { value: item.bankCode, label: item.bankName };
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .tradeFinance .pagination {
    text-align: right;
    margin: 10px 0;
  }
  .tradeFinance .main-content {
    border-radius: 4px;
    padding: 10px;
    background: #fff;
    -webkit-box-shadow: 0px 1px 5px #ddd;
    box-shadow: 0px 1px 5px #ddd;
  }
  .btn {
    height: 30px;
    line-height: 30px;
    min-width: 80px;
    border-radius: 3px;
    font-size: 12px;
  }
</style>
